import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=7a9d869c&scoped=true"
import script from "./contentBox.vue?vue&type=script&lang=js"
export * from "./contentBox.vue?vue&type=script&lang=js"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=7a9d869c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d869c",
  null
  
)

export default component.exports